import { graphql, useStaticQuery } from "gatsby";
import { ColorOptions, MulticolorCode } from "../utils/colorTypes";

type ColorType = Record<string, string | MulticolorCode[]>;

export const useProductColors: () => ColorType = () => {
  const data: ColorOptions = useStaticQuery(graphql`
    query {
      wpOptions {
        data {
          variation_colors_and_images {
            color_code
            multicolor_codes {
              multicolor_code
            }
            one_color_multicolor
            variation_value
          }
        }
      }
    }
  `);

  // prettier-ignore
  const colors = data.wpOptions.data.variation_colors_and_images
    .reduce<ColorType>((acc, val) => {
      const key = val.variation_value.replaceAll(" ", "-").toLowerCase();

      acc[key] = val.color_code === null ? val.multicolor_codes : val.color_code;

      return acc;
    }, {});

  return colors;
};
